import camelCase from 'lodash/camelCase';
import Assignees from '@/constants/Assignees';
import SortOrder from '@/constants/SortOrder';

export const ModalType = Object.freeze({
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
});

export const CreateEditDefaultValues = Object.freeze({
  attachments: [],
  constituents: null,
  developers: [],
  dueDate: new Date(),
  taskNotes: '',
  taskTitle: '',
});

export const TaskSortBy = Object.freeze({
  DUE_DATE: 'due_date',
  TASK_TITLE: 'task_title',
  CREATED: 'created',
});

export const TaskStatusEnum = Object.freeze({
  ALL: 'all',
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
});

export const TaskFilterParams = Object.freeze({
  status: {
    type: String,
    defaultValue: TaskStatusEnum.INCOMPLETE,
  },
  userId: {
    type: String,
    defaultValue: Assignees.ALL,
  },
});

export const TaskSortableFields = Object.freeze(
  Object.entries({
    [TaskSortBy.DUE_DATE]: {
      defaultValue: SortOrder.ASC,
      isDefault: true,
    },
    [TaskSortBy.TASK_TITLE]: {
      defaultValue: SortOrder.ASC,
    },
    [TaskSortBy.CREATED]: {
      defaultValue: SortOrder.DESC,
    },
  }).reduce((obj, [key, value]) => ({ ...obj, [camelCase(key)]: value }), {}),
);
